import React, { useState, useEffect } from 'react';
import './TypewriterSlogan.css';

const TypewriterSlogan = ({ text, delay = 100 }) => {
  const [currentText, setCurrentText] = useState('');
  const [currentIndex, setCurrentIndex] = useState(0);
  const [typingComplete, setTypingComplete] = useState(false);

  useEffect(() => {
    if (currentIndex < text.length) {
      const timeout = setTimeout(() => {
        setCurrentText(prevText => prevText + text[currentIndex]);
        setCurrentIndex(prevIndex => prevIndex + 1);
      }, delay);
      return () => clearTimeout(timeout);
    } else {
      setTypingComplete(true);
    }
  }, [currentIndex, delay, text]);

  return (
    <span className="typewriter-text">
      {currentText}
      <span className={`typewriter-cursor ${typingComplete ? 'hidden' : ''}`}></span>
    </span>
  );
};

export default TypewriterSlogan;